import React, { useEffect, useState } from "react";
import Layouts from "../../components/Layouts";
import { getDirectusClient } from "../../lib/directus";
import { List, Button, Card, Modal, Checkbox, message, Space } from "antd";
import { useNavigate } from "react-router-dom";
import { readRoles, readItems, updateRole } from "@directus/sdk";
import { useSelector } from "react-redux";
import validarpermiso from "../../lib/utils";

function Roles() {
  const [roles, setRoles] = useState([]);
  const navigate = useNavigate();
  const permisos = useSelector((state) => state.permisos);

  const [isMenuModalVisible, setIsMenuModalVisible] = useState(false);
  const [menuItems, setMenuItems] = useState([]);
  const [selectedMenuItems, setSelectedMenuItems] = useState([]);
  const [initialMenuData, setInitialMenuData] = useState([]); // [{ id: junctionId, menu_id: menuId }]
  const [currentRole, setCurrentRole] = useState(null);
  const [loading, setLoading] = useState(false);

  const getRoles = async () => {
    try {
      const directus = await getDirectusClient();
      const response = await directus.request(
        readRoles({
          fields: ["*", "menus.id", "menus.menu_id"], // Obtener ambos IDs
        })
      );
      setRoles(response);
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  const showMenuModal = async (role) => {
    setCurrentRole(role);
    setLoading(true);
    try {
      const directus = await getDirectusClient();
      const menuResponse = await directus.request(
        readItems("menu", {
          fields: ["id", "label"],
          sort: ["label"],
        })
      );

      setMenuItems(menuResponse);

      // Guardar datos iniciales de la relación
      const initialRelations = role.menus?.map(menu => ({
        junctionId: menu.id, // ID de la relación
        menuId: menu.menu_id // ID del menú
      })) || [];
      
      setInitialMenuData(initialRelations);
      setSelectedMenuItems(initialRelations.map(rel => rel.menuId));

      setIsMenuModalVisible(true);
    } catch (error) {
      console.error("Error loading menu items:", error);
      message.error("Error al cargar los menús");
    } finally {
      setLoading(false);
    }
  };

  const handleMenuUpdate = async () => {
    setLoading(true);
    try {
      const directus = await getDirectusClient();

      // Obtener IDs de menús seleccionados
      const selectedMenuIds = selectedMenuItems;

      // Encontrar relaciones a eliminar (las que estaban inicialmente pero no están seleccionadas)
      const relationsToDelete = initialMenuData.filter(
        rel => !selectedMenuIds.includes(rel.menuId)
      );

      // Encontrar menús a agregar (los seleccionados que no estaban inicialmente)
      const menusToAdd = selectedMenuIds.filter(
        menuId => !initialMenuData.some(rel => rel.menuId === menuId)
      );

      // Preparar payload
      const payload = {
        menus: {
          create: menusToAdd.map(menuId => ({ menu_id: menuId })),
          delete: relationsToDelete.map(rel => rel.junctionId) // Usar solo el ID de la relación
        }
      };

      if (menusToAdd.length > 0 || relationsToDelete.length > 0) {
        await directus.request(
          updateRole(currentRole.id, payload)
        );
        message.success("Menús actualizados exitosamente");
      } else {
        message.info("No se detectaron cambios");
      }

      setIsMenuModalVisible(false);
      getRoles();
    } catch (error) {
      console.error("Error updating menu items:", error);
      message.error("Error al actualizar los menús");
    }
    setLoading(false);
  };

  useEffect(() => {
    getRoles();
  }, []);

  const checkboxOptions = menuItems.map((item) => ({
    label: item.label,
    value: item.id,
  }));

  return (
    <Layouts>
      {validarpermiso("directus_roles", "read", permisos) ? (
        <Card title="Lista de Roles" style={{ width: "100%" }}>
          <List
            dataSource={roles}
            renderItem={(role) => (
              <List.Item
                actions={[
                  validarpermiso("directus_roles", "update", permisos) && (
                    <Space>
                      <Button
                        type="primary"
                        onClick={() =>
                          navigate(`/permisions`, {
                            state: { id: role.id, role: role },
                          })
                        }
                      >
                        Gestionar Permisos
                      </Button>
                      <Button onClick={() => showMenuModal(role)}>
                        Gestionar Menú
                      </Button>
                    </Space>
                  ),
                ]}
              >
                <List.Item.Meta
                  title={role.name}
                  description={role.description || "Sin descripción"}
                />
              </List.Item>
            )}
          />

          <Modal
            title="Gestionar Menú"
            open={isMenuModalVisible}
            onOk={handleMenuUpdate}
            onCancel={() => setIsMenuModalVisible(false)}
            confirmLoading={loading}
            width={600}
          >
            <Checkbox.Group
              options={checkboxOptions}
              value={selectedMenuItems}
              onChange={setSelectedMenuItems}
              style={{ display: "flex", flexDirection: "column", gap: "8px" }}
            />
          </Modal>
        </Card>
      ) : (
        <h3>No tiene permisos para ver roles</h3>
      )}
    </Layouts>
  );
}

export default Roles;